import PATH from '../paths';

const name = 'Just Property';
const key = 'justproperty';
const imgUrl = `${ PATH.CDN }/whitelabels/${ key }`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/logo.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  logoSidebar: `${ imgUrl }/logo-sidebar.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/bg.jpg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-jp-blue:                 #034F84;
    --color-jp-yellow:                #F7D54C;
    --color-xusa-blueLight:           #818a91;

    --color-primary:                  var(--color-jp-blue);
    --color-secondary:                var(--color-jp-yellow);
    --color-accent:                   var(--color-white);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-jp-blue);
    --color-link-hover:               var(--color-darker);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              var(--color-jp-blue);
    --anonymous-copy-bg:              var(--color-jp-blue);
    --anonymous-heading-color:        var(--color-jp-yellow);
    --anonymous-subheading-color:     var(--color-white);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          50px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-jp-blue);
    --sidebar-logo-bg-color: var(--color-white);
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color-xusa-blueLight);

    --sidebar-button-color: var(--color-accent);
    --sidebar-button-color-active: var(--color-white);
    --sidebar-button-color-hover: var(--color-jp-blue);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-jp-yellow);
    --sidebar-button-bg-color-hover: var(--color-accent);
    --sidebar-button-border-color: var(--color-accent);
    --sidebar-button-border-color-active: var(--color-jp-yellow);
    --sidebar-button-border-color-hover: var(--color-accent);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-jp-blue);
    --btn-primary--border:            var(--color-jp-blue);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-jp-yellow);
    --btn-primary--borderH:           var(--color-jp-yellow);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-jp-blue);
    --btn-secondary--color:           var(--color-jp-blue);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-dark);
    --btn-secondary--colorH:          var(--color-dark);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
